import React from 'react';
import PropTypes from 'prop-types';

import BuildingList from './BuildingList';
import SortAndFilters from './SortAndFilters';
import { sortFunctions, filterFunctions } from './lib';

class Browse extends React.Component {
	static propTypes = {
	  baseUrl: PropTypes.string,
	  buildings: PropTypes.array,
	  activeFilters: PropTypes.array,
	  sort: PropTypes.string,
	  browseType: PropTypes.string,
	  browse: PropTypes.object,
	  handlers: PropTypes.object,
	  toggleOnlyShowFreeHandler: PropTypes.func,
	  removeFilterTagHandler: PropTypes.func,
	  changeBrowseTypeHandler: PropTypes.func,
	  browseSortChangeHandler: PropTypes.func,
	}

	shouldComponentUpdate(nextProps) {
	  const differentActiveFilters = JSON.stringify(nextProps.activeFilters) !== JSON.stringify(this.props.activeFilters);
	  const differentSort = nextProps.sort !== this.props.sort;
	  const differentBrowseType = nextProps.browseType !== this.props.browseType;
	  const differentFreeToggle = nextProps.browse.onlyShowBuildingsWithFreeSpaces !== this.props.browse.onlyShowBuildingsWithFreeSpaces;

	  return differentActiveFilters || differentSort || differentBrowseType || differentFreeToggle;
	}

	render() {
	  const { onlyShowBuildingsWithFreeSpaces } =  this.props.browse;

	  const filterBuildings = building => {
	    const hasFilters = this.props.activeFilters.length > 0;
	    let filterTypes = this.props.activeFilters.map(filter => filter.type);
	    const typeFilters = this.props.activeFilters.filter(filter => filter.type === 'spaceType');
	    const areaFilters = this.props.activeFilters.filter(filter => filter.type === 'area');
	    let show = true;

	    if (areaFilters.length === 2) {
	      const min = areaFilters.find(filter => filter.key === 'min');
	      const max = areaFilters.find(filter => filter.key === 'max');

	      show = (
	        show &&
					building.spaces.some(space => {
						return (
							space.area >= min.value &&
							space.area <= max.value &&
							(typeFilters.length === 0 || typeFilters.some(filter => filter.value === space.type)) &&
							(!onlyShowBuildingsWithFreeSpaces || space.isFree)
					  )
					})
	      );
	    } else {
	      areaFilters.forEach(filter => {
	        show = show && filterFunctions[filter.type]({ show, filter, building, hasFilters, onlyShowBuildingsWithFreeSpaces });
	      });
	    }

	    filterTypes.forEach(type => {
	      if (type !== 'area') {
	        let typeShow = false;

	        this.props.activeFilters.forEach(filter => {
	          if (type === filter.type && filter.type in filterFunctions) {
	            typeShow = typeShow || filterFunctions[filter.type]({ show, filter, building, hasFilters, onlyShowBuildingsWithFreeSpaces });
	          }
	        });

	        show = show && typeShow;
	      }
	    });

	    // If user only want's buildings with available spaces
	    if (onlyShowBuildingsWithFreeSpaces) {
	      show = show && building.spaces.some(space => {
	        if (typeFilters.length > 0) {
	          return (typeFilters.some(filter => filter.value === space.type) && space.isFree);
	        }

	        return space.isFree;
	      });
	    }

	    return show;
	  }

	  const sortFunction = this.props.sort in sortFunctions ? sortFunctions[this.props.sort] : () => 1;
	  const buildings = this.props.buildings.filter(filterBuildings).sort(sortFunction);

	  return (
	    <React.Fragment>
	      <SortAndFilters
	        sort={this.props.sort}
	        activeFilters={this.props.activeFilters}
	        buildingCount={buildings.length}
	        browse={this.props.browse}
	        browseType={this.props.browseType}
	        toggleOnlyShowFreeHandler={this.props.toggleOnlyShowFreeHandler}
	        removeFilterTag={this.props.removeFilterTagHandler}
	        changeBrowseTypeHandler={this.props.changeBrowseTypeHandler}
	        browseSortChangeHandler={this.props.browseSortChangeHandler}
	      />
	      <BuildingList
	        activeFilters={this.props.activeFilters}
	        onlyFree={onlyShowBuildingsWithFreeSpaces}
	        unfilteredLength={this.props.buildings.length}
	        browseType={this.props.browseType}
	        buildings={buildings}
	        baseUrl={this.props.baseUrl}
	      />
	    </React.Fragment>
	  );
	}
}

export default Browse;
